import PropTypes from 'prop-types';

const tableFilterValuesShape = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  isChecked: PropTypes.bool,
}));

export { tableFilterValuesShape };
